export default function Footer() {
  return (
    <footer className="border-t border-zinc-200 bg-zinc-950 text-zinc-300">
      <div className="container mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display font-black text-2xl text-white tracking-tight">NOMAD CARAVAN<br/>REPAIRS</div>
          <p className="mt-4 text-sm text-zinc-400 max-w-sm">Insurance and private caravan repairs across the Whitsundays. Rebuilding dreams, one van at a time.</p>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#22C55E] mt-6">
            ◆ BOWEN · WHITSUNDAYS · QLD
          </div>
        </div>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-4">Navigate</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-white">Home</a></li>
            <li><a href="/services" className="hover:text-white">Services We Offer</a></li>
            <li><a href="/spare-parts" className="hover:text-white">Spare Parts</a></li>
            <li><a href="/gallery" className="hover:text-white">Gallery</a></li>
            <li><a href="/jobs" className="hover:text-white">Join the Team</a></li>
            <li><a href="/troubleshooting" className="hover:text-white">Troubleshooting</a></li>
            <li><a href="/local-services" className="hover:text-white">Local Services</a></li>
          </ul>
        </div>
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-4">Get in touch</div>
          <p className="text-sm">Use the AI Receptionist at the bottom right — Rosie will route your enquiry to the right technician within one business day.</p>
        </div>
      </div>
      <div className="border-t border-zinc-800">
        <div className="container mx-auto px-6 py-6 flex justify-between text-xs text-zinc-500 font-mono">
          <span>© {new Date().getFullYear()} NOMAD CARAVAN REPAIRS</span>
          <span>REBUILDING DREAMS · ONE VAN AT A TIME</span>
        </div>
      </div>
    </footer>
  );
}
